import { Link } from 'react-router-dom';
import { QrCode, Share2, UserCircle, Users } from 'lucide-react';
import RecentProfiles from '../components/RecentProfiles';

export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-transparent">
      <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
        {/* Section Hero */}
        <div className="text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl md:text-6xl">
            <span className="block">Votre profil professionnel,</span>
            <span className="block text-primary-600">instantanément partageable</span>
          </h1>
          <p className="mt-3 max-w-md mx-auto text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
            Créez votre profil professionnel et générez un QR code qui partage instantanément vos coordonnées via vCard. Réseautez plus intelligemment.
          </p>
          <div className="mt-5 max-w-md mx-auto sm:flex sm:justify-center md:mt-8">
            <div className="rounded-md shadow">
              <Link
                to="/register"
                className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 md:py-4 md:text-lg md:px-10"
              >
                Commencer
              </Link>
            </div>
          </div>
        </div>

        {/* Section Fonctionnalités */}
        <div className="mt-20">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-3">
            <div className="p-6 bg-white rounded-lg shadow-md">
              <UserCircle className="h-12 w-12 text-primary-600 mb-4" />
              <h3 className="text-xl font-semibold text-gray-900">Créer un Profil</h3>
              <p className="mt-2 text-gray-600">
                Construisez votre profil professionnel avec toutes vos coordonnées et références.
              </p>
            </div>

            <div className="p-6 bg-white rounded-lg shadow-md">
              <QrCode className="h-12 w-12 text-primary-600 mb-4" />
              <h3 className="text-xl font-semibold text-gray-900">Générer un QR Code</h3>
              <p className="mt-2 text-gray-600">
                Obtenez un QR code unique contenant vos informations vCard pour un partage facile.
              </p>
            </div>

            <div className="p-6 bg-white rounded-lg shadow-md">
              <Share2 className="h-12 w-12 text-primary-600 mb-4" />
              <h3 className="text-xl font-semibold text-gray-900">Partager Instantanément</h3>
              <p className="mt-2 text-gray-600">
                Laissez les autres scanner votre QR code pour enregistrer instantanément vos coordonnées.
              </p>
            </div>
          </div>
        </div>

        {/* Section Profils Récents */}
        <RecentProfiles />
      </div>
    </div>
  );
}